import { render, staticRenderFns } from "./add-btn.vue?vue&type=template&id=7a587b57&scoped=true&"
import script from "./add-btn.vue?vue&type=script&lang=js&"
export * from "./add-btn.vue?vue&type=script&lang=js&"
import style0 from "./add-btn.vue?vue&type=style&index=0&id=7a587b57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a587b57",
  null
  
)

export default component.exports